module.exports = __webpack_public_path__ + "img/16.22c6ecd3.jpg";